





































import Vue from 'vue';
import NOC from '@/class/common/const';

export default Vue.extend({
  name: 'QuitLoginModal',
  props: {
    display: String,
  },
  computed: {
    QUIT(): boolean {
      return this.display === NOC.CONTRACT.QUIT;
    },
    CONFIRM(): boolean {
      return this.display === NOC.CONTRACT.CONFIRM;
    },
    DENY(): boolean {
      return this.display === NOC.CONTRACT.DENY;
    },
  },
});
